/**
 * HAFA Product Lightbox
 * --------------------------------------------------------------
 * Eigenständige Lightbox für Produktbilder. Umgeht das defekte
 * Dawn-Modal komplett.
 *
 * - Klick auf jedes Galerie-Bild öffnet das Overlay mit dem
 *   geklickten Bild.
 * - Pfeil-Buttons + Tastatur (←/→/Esc) navigieren durch alle
 *   Bilder der aktuellen Produktseite.
 * - Klick außerhalb des Bilds schließt; Klick auf Pfeile NICHT.
 * - Mobile-friendly (Swipe optional, Pfeile bleiben sichtbar).
 *
 * Stand: 2026-04-30 / schodyhafa.pl
 */
(function () {
  "use strict";
  if (window.__HAFA_LB_V1__) return;
  window.__HAFA_LB_V1__ = true;

  // ---------- CSS injizieren (selbständig, kein File-Conflict) ----------
  const css = `
#hafa-lb { position: fixed; inset: 0; background: rgba(20,20,20,.32); -webkit-backdrop-filter: blur(14px) saturate(120%); backdrop-filter: blur(14px) saturate(120%); z-index: 100000; display: none; align-items: center; justify-content: center; padding: 4vh 4vw 8vh; box-sizing: border-box; }
#hafa-lb.open { display: flex; }
#hafa-lb__stage { max-width: 100%; max-height: 100%; display: flex; align-items: center; justify-content: center; }
#hafa-lb__img { max-width: 100%; max-height: 86vh; width: auto; height: auto; object-fit: contain; user-select: none; pointer-events: none; box-shadow: 0 8px 32px rgba(0,0,0,.18); border-radius: 16px; background: #fff; }
.hafa-lb__btn { position: fixed; background: rgba(255,255,255,.95); border: 1px solid rgba(0,0,0,.08); border-radius: 50%; cursor: pointer; padding: 0; transition: background .15s, transform .15s, box-shadow .15s; z-index: 100001; box-shadow: 0 4px 14px rgba(0,0,0,.18); display: flex; align-items: center; justify-content: center; }
.hafa-lb__btn:hover { background: #fff; transform: scale(1.05); box-shadow: 0 6px 20px rgba(0,0,0,.22); }
.hafa-lb__btn svg { width: 22px; height: 22px; display: block; }
.hafa-lb__close { top: 18px; right: 18px; width: 44px; height: 44px; }
.hafa-lb__prev, .hafa-lb__next { top: 50%; transform: translateY(-50%); width: 52px; height: 52px; }
.hafa-lb__prev:hover, .hafa-lb__next:hover { transform: translateY(-50%) scale(1.05); }
.hafa-lb__prev { left: 18px; }
.hafa-lb__next { right: 18px; }
.hafa-lb__prev svg, .hafa-lb__next svg { width: 24px; height: 24px; }
.hafa-lb__counter { position: fixed; bottom: 22px; left: 50%; transform: translateX(-50%); color: #fff; background: rgba(0,0,0,.55); padding: 6px 14px; border-radius: 20px; font-size: 13px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; z-index: 100001; letter-spacing: .02em; }
@media (max-width: 749px) {
  #hafa-lb { padding: 6vh 2vw 8vh; }
  #hafa-lb__img { max-height: 80vh; }
  .hafa-lb__close { width: 40px; height: 40px; top: 8px; right: 8px; }
  .hafa-lb__prev, .hafa-lb__next { width: 44px; height: 44px; }
  .hafa-lb__prev { left: 6px; }
  .hafa-lb__next { right: 6px; }
  .hafa-lb__btn svg { width: 18px; height: 18px; }
  .hafa-lb__prev svg, .hafa-lb__next svg { width: 20px; height: 20px; }
}
body.hafa-lb-open { overflow: hidden; }
`;
  const style = document.createElement("style");
  style.id = "hafa-lb-style";
  style.textContent = css;
  document.head.appendChild(style);

  // ---------- Overlay-DOM bauen ----------
  const overlay = document.createElement("div");
  overlay.id = "hafa-lb";
  // SVG-Icons für pixelgenaue Zentrierung (statt Unicode-Glyphen)
  const ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  const ICON_LEFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
  const ICON_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
  overlay.innerHTML = `
    <div id="hafa-lb__stage"><img id="hafa-lb__img" alt=""></div>
    <button class="hafa-lb__btn hafa-lb__close" aria-label="Schließen" type="button">${ICON_X}</button>
    <button class="hafa-lb__btn hafa-lb__prev" aria-label="Zurück" type="button">${ICON_LEFT}</button>
    <button class="hafa-lb__btn hafa-lb__next" aria-label="Weiter" type="button">${ICON_RIGHT}</button>
    <div class="hafa-lb__counter" id="hafa-lb__counter"></div>
  `;
  document.body.appendChild(overlay);

  const $ = (s, r) => (r || document).querySelector(s);
  const imgEl = $("#hafa-lb__img");
  const counterEl = $("#hafa-lb__counter");
  const prevBtn = $(".hafa-lb__prev");
  const nextBtn = $(".hafa-lb__next");
  const closeBtn = $(".hafa-lb__close");

  let images = [];
  let currentIdx = 0;

  // ---------- Bildquellen aus Galerie sammeln ----------
  // Strategie: nur sichtbare <li class="product__media-item"> — das sind die
  // Slider-Slides der Hauptgalerie. Keine doppelten DIV-Container, keine
  // Variant-spezifischen versteckten Bilder, keine Thumbnails.
  // Jeder Eintrag bekommt eine .el-Referenz für robustes Element-Mapping.
  function collectImages() {
    const items = document.querySelectorAll(
      "ul.product__media-list > li.product__media-item, ol.product__media-list > li.product__media-item"
    );
    const out = [];
    const seen = new Set();
    items.forEach(function (el) {
      // Variant-spezifische Bilder ausschließen
      if (el.classList.contains("product__media-item--variant")) return;
      // Im DOM versteckte Items ausschließen
      const cs = window.getComputedStyle(el);
      if (cs.display === "none" || cs.visibility === "hidden") return;
      const img = el.querySelector("img");
      if (!img || !img.src) return;
      const entry = toEntry(img);
      if (seen.has(entry.src)) return;
      seen.add(entry.src);
      entry.el = el;
      out.push(entry);
    });
    return out;
  }

  function toEntry(img) {
    let src = img.getAttribute("src") || img.currentSrc || "";
    if (src.startsWith("//")) src = "https:" + src;
    src = src
      .replace(/(_)?\d+x(\d+)?\.(jpg|jpeg|png|webp)/i, "$1.$3")
      .replace(/&width=\d+/i, "&width=2048")
      .replace(/\?width=\d+/i, "?width=2048");
    return { src, alt: img.getAttribute("alt") || "" };
  }

  // ---------- Render ----------
  function render() {
    if (!images.length) return;
    const it = images[currentIdx];
    imgEl.src = it.src;
    imgEl.alt = it.alt;
    counterEl.textContent = `${currentIdx + 1} / ${images.length}`;
    const showNav = images.length > 1;
    prevBtn.style.display = showNav ? "" : "none";
    nextBtn.style.display = showNav ? "" : "none";
    counterEl.style.display = showNav ? "" : "none";
  }

  function open(startIdx) {
    images = collectImages();
    if (!images.length) return;
    currentIdx = Math.min(Math.max(0, startIdx || 0), images.length - 1);
    overlay.classList.add("open");
    document.body.classList.add("hafa-lb-open");
    render();
  }

  function close() {
    overlay.classList.remove("open");
    document.body.classList.remove("hafa-lb-open");
  }

  function next() {
    currentIdx = (currentIdx + 1) % images.length;
    render();
  }
  function prev() {
    currentIdx = (currentIdx - 1 + images.length) % images.length;
    render();
  }

  // ---------- Events ----------
  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    close();
  });
  prevBtn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    prev();
  });
  nextBtn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    next();
  });
  // Klick auf Backdrop (alles außer Bild + Buttons) schließt
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay || e.target === imgEl || e.target.id === "hafa-lb__stage") {
      close();
    }
  });
  // Tastatur
  document.addEventListener("keydown", function (e) {
    if (!overlay.classList.contains("open")) return;
    if (e.key === "Escape") {
      close();
    } else if (e.key === "ArrowLeft") {
      prev();
    } else if (e.key === "ArrowRight") {
      next();
    }
  });

  // ---------- Galerie-Klicks abfangen ----------
  // Idee: jedes Click auf ein Galerie-Element wird abgefangen, Default verhindert,
  // unsere Lightbox geöffnet. Bilder-Liste wird im Moment des Öffnens neu gesammelt
  // (für Variantenwechsel etc.).
  document.addEventListener(
    "click",
    function (e) {
      const trigger = e.target.closest(
        ".product__modal-opener, .product__media-list .product__media, .product__media-list .product__media-item, [data-media-id]"
      );
      if (!trigger) return;

      // Nur in der Galerie der Hauptproduktseite — nicht z. B. auf Mini-Cards oder Empfehlungen
      const inGallery = trigger.closest(".product__media-list, media-gallery, product-modal");
      if (!inGallery) return;

      // Wenn schon innerhalb unserer Lightbox — ignorieren
      if (e.target.closest("#hafa-lb")) return;

      // Index ermitteln aus der Reihenfolge der Galerie-Bilder
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      const allImgs = collectImages();

      // 1. Versuch: Position über DOM-Containment.
      //    Finde das <li>, das den Trigger enthält, und mappe auf den Index
      //    in unserer collectImages-Liste via Element-Referenz.
      let startIdx = -1;
      const containingLi = trigger.closest("li.product__media-item");
      if (containingLi) {
        startIdx = allImgs.findIndex(function (it) {
          return it.el === containingLi;
        });
      }

      // 2. Fallback: URL-basiertes Matching (für Edge-Cases ohne <li>-Wrapper)
      if (startIdx < 0) {
        const triggerImg = trigger.querySelector("img") || (trigger.tagName === "IMG" ? trigger : null);
        if (triggerImg) {
          const triggerEntry = toEntry(triggerImg);
          startIdx = allImgs.findIndex(function (it) {
            return it.src === triggerEntry.src;
          });
        }
      }

      // 3. Letzter Fallback: bei aria-label "Medien N in Modal öffnen" → Index N-1
      if (startIdx < 0) {
        const ariaLabel = trigger.getAttribute("aria-label") || "";
        const m = ariaLabel.match(/(\d+)/);
        if (m) {
          const num = parseInt(m[1], 10);
          if (num > 0 && num <= allImgs.length) startIdx = num - 1;
        }
      }

      if (startIdx < 0) startIdx = 0;
      open(startIdx);
    },
    true // Capture-Phase: greift VOR Dawn-Modal-Logik
  );

  // ---------- Dawn-Modal abklemmen ----------
  // Falls das alte Dawn-Modal trotzdem offen geht, sofort schließen.
  document.addEventListener("modalOpen", function (e) {
    const t = e.target;
    if (t && t.tagName && t.tagName.toLowerCase() === "product-modal") {
      // Verhindere, dass es sichtbar wird
      try {
        if (typeof t.hide === "function") t.hide();
      } catch (err) {}
    }
  }, true);
})();
